import React from "react";
import { Link } from "react-router-dom";
import "./NewsCard.css";

/**
 * Single news card used in home/category grid listings.
 * news: { id, title, description, image, category, categorySlug, timeAgo, isVideo }
 */
function NewsCard({ news, variant = "default" }) {
  const { id, title, description, image, category, categorySlug, timeAgo, isVideo, trending } = news;
  const detailsPath = `/news/${categorySlug}/${id}`;

  return (
    <article className={`tt-card-wrap tt-card-${variant}`}>
      <Link to={detailsPath} className="tt-card-media-link">
        <div className="tt-card-media">
          {image ? (
            <img
              src={image || "/assets/icon.png"}
              alt={title}
              className="tt-card-image"
              loading="lazy"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = "/assets/icon.png";
              }}
            />
          ) : (
            <div className="tt-card-image-fallback" aria-hidden="true" />
          )}
          {trending && <span className="tt-card-trending">Trending</span>}
          {isVideo && (
            <span className="tt-card-play" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <polygon points="6,4 20,12 6,20" fill="currentColor" />
              </svg>
            </span>
          )}
        </div>
      </Link>

      <div className="tt-card-body">
        <Link to={detailsPath} className="tt-card-title-link">
          <h3 className="tt-card-title">{title}</h3>
        </Link>
        {description && <p className="tt-card-description">{description}</p>}

        <div className="tt-card-meta">
          {timeAgo && <span className="tt-card-time">{timeAgo}</span>}
          {timeAgo && categorySlug && <span className="tt-card-dot">|</span>}
          {categorySlug && (
            <Link to={`/category/${categorySlug}`} className="tt-card-category">
              {category}
            </Link>
          )}
        </div>
      </div>
    </article>
  );
}

export default NewsCard;
